import {createStore} from 'vuex'
import {Actions, Mutations} from "@/store/enum/StoreEnums";

import AuthModule from "@/store/module/AuthModule";
import BodyModule from "@/store/module/BodyModule";
import BreadcrumbsModule from "@/store/module/BreadcrumbsModule";
import ConfigModule from "@/store/module/ConfigModule";
import User from "@/store/user";
import UserRole from "@/store/user/Role";
import Company from "@/store/company";
import CompanyType from "@/store/company/Type.js";
import CompanySpecialty from "@/store/company/Specialty.js";
import CompanyOfficer from "@/store/company/Officer.js";
import CompanyCustomer from "@/store/company/Customer.js";
import CompanyDomain from "@/store/company/Domain.js";
import EcommerceProduct from "@/store/ecommerce/product";
import EcommerceProductPrice from "@/store/ecommerce/product/Price";
import EcommerceProductModule from "@/store/ecommerce/product/Module";
import EcommerceProductResource from "@/store/ecommerce/product/Resource";
import EcommerceProductDependency from "@/store/ecommerce/product/Dependency";
import EcommerceProductUpgradePath from "@/store/ecommerce/product/UpgradePath";
import EcommerceSubscription from "@/store/ecommerce/subscription";
import EcommerceCheckout from "@/store/ecommerce/checkout";
import EcommerceCheckoutNote from "@/store/ecommerce/checkout/Note";
import EcommercePromotion from "@/store/ecommerce/Promotion";
import EcommercePaymentMethod from "@/store/ecommerce/PaymentMethod";
import Module from "@/store/module";
import ModuleAssignment from "@/store/module/assignment";
import ModuleKind from "@/store/module/Kind.js";
import Note from "@/store/module/note";
import NoteCategory from "@/store/module/note/Category";
import NoteTag from "@/store/module/note/Tag";
import NoteTrash from "@/store/module/note/Trash";
import Agenda from "@/store/module/agenda";
import VehicleBrand from "@/store/common/vehicle/Brand";
import VehicleModel from "@/store/common/vehicle/Model";
import VehicleModelSearch from "@/store/common/vehicle/ModelSearch";
import VehicleYear from "@/store/common/vehicle/Year";
import Unit from "@/store/common/stock/Unit";
import Currency from "@/store/common/localization/Currency";

export const store = createStore({
    state: () => ({
        access: true,
        forbiddenEndpoints: []
    }),
    getters: {
        isAccess(state) {
            return state.access;
        },
        forbiddenEndpoints(state) {
            return state.forbiddenEndpoints;
        }
    },
    actions: {
        [Actions.ACCESS](context, access) {
            context.commit(Mutations.SET_ACCESS, access);
        },
        [Actions.FORBIDDEN_ENDPOINT](context, access) {
            context.commit(Mutations.SET_FORBIDDEN_ENDPOINT, access);
        }
    },
    mutations: {
        [Mutations.SET_ACCESS](state, access) {
            state.access = access;
        },
        [Mutations.SET_FORBIDDEN_ENDPOINT](state, endpoint) {
            state.forbiddenEndpoints.push(endpoint);
        },
        [Mutations.RESET_FORBIDDEN_ENDPOINT](state) {
            state.forbiddenEndpoints = [];
        },
    },
    modules: {
        AuthModule,
        BodyModule,
        BreadcrumbsModule,
        ConfigModule,
        user: Object.assign(User, {
            modules: {
                role: UserRole
            }
        }),
        company: Object.assign(Company, {
            modules: {
                type: CompanyType,
                specialty: CompanySpecialty,
                officer: CompanyOfficer,
                customer: CompanyCustomer,
                domain: CompanyDomain,
            }
        }),
        ecommerce: {
            namespaced: true,
            modules: {
                product: Object.assign(EcommerceProduct, {
                    modules: {
                        price: EcommerceProductPrice,
                        module: EcommerceProductModule,
                        resource: EcommerceProductResource,
                        dependency: EcommerceProductDependency,
                        upgrade_path: EcommerceProductUpgradePath,
                    }
                }),
                subscription: EcommerceSubscription,
                checkout: Object.assign(EcommerceCheckout, {
                    modules: {
                        note: EcommerceCheckoutNote,
                    }
                }),
                promotion: EcommercePromotion,
                payment_method: EcommercePaymentMethod,
            }
        },
        module: Object.assign(Module, {
            modules: {
                assignment: ModuleAssignment,
                kind: ModuleKind,
                note: Object.assign(Note, {
                    modules: {
                        category: NoteCategory,
                        tag: NoteTag,
                        trash: NoteTrash,
                    }
                }),
                agenda: Agenda,
            }
        }),
        common: {
            namespaced: true,
            modules: {
                vehicle: {
                    namespaced: true,
                    modules: {
                        brand: VehicleBrand,
                        model: VehicleModel,
                        search: VehicleModelSearch,
                        year: VehicleYear,
                    }
                },
                unit: Unit,
                currency: Currency,
            }
        },
    }
});


export default store;